import React, { useState } from "react";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { message } from "antd";
import { useMediaQuery } from "react-responsive";
import theme from "./Theme";
import { Product } from "./dummyprduct";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { API_URL } from "./Config";


interface AllcarditemsProps {
  product: Product;
}

interface LineItem {
  product: string;
  quantity: number;
  discountInPercent: number;
  productPrice: number;
  discountedPrice: number;
}

interface OrderData {
  orderId: number;
  lineItems: LineItem[];
  type: string;
  deliverySlot: string;
  address: string;
  paymentMethod: string;
  paymentStatus: string;
  status: string;
  deliveryInstructions: string;
  isCancelled: boolean;
  cancellationReason: string | null;
  refundStatus: string;
  paymentAmount: number;
  productName: string;
  originalPrice: number;
  originalQuantity: number;
  totalAmount: number;
  discountInPercent: number;
}

const CardItem: React.FC<AllcarditemsProps> = ({ product }) => {
  
  const [weight, setWeight] = useState(product?.minWeightInGrams);
  // const [qty, setQty] = useState(1);
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const isSmallDevice = useMediaQuery({ query: "(max-width: 767px)" });

 // Price calculation
  const totalPrice = (weight / product.minWeightInGrams) * product.price;
  // const totalPrice = qty * product.price;
  const discountAmount = totalPrice * (product.discountInPercent / 100);
  const finalPrice = (totalPrice - discountAmount).toFixed(2);

  const handleIncrement = () => {
    setWeight((prevWeight) => (prevWeight < 1500 ? prevWeight + 100 : prevWeight));
  };

  const handleDecrement = () => {
    if (weight > product.minWeightInGrams) {
      setWeight((prevWeight) => prevWeight - 100);
    }
  };
  // const handleIncrement = () => {
  //   setQty((preQty) => (preQty < 10 ? preQty + 1 : preQty));
  // };

  // const handleDecrement = () => {

  //     setQty((prevQty) => (prevQty > 1 ? prevQty - 1 : prevQty));

  // };

  const handleNavProductDetail = (slug: string) => {
    navigate(`/${slug}`);
  };

  const successmessage = (content: string) => {
    messageApi.open({
      type: "success",
      content: content,
      style: { fontSize: "16px", fontWeight: "bold" },
    });
  };

  const handleAddToCart = () => {
    let cart = JSON.parse(localStorage.getItem("cart") || "[]");

    const orderData: OrderData = {
      orderId: Date.now(),
      lineItems: [
        {
          product: product._id,
          // quantity: qty,
          quantity: weight,
          productPrice: product.price,
          discountInPercent: product.discountInPercent,
          discountedPrice: product.price - (product.price * product.discountInPercent) / 100,
        },
      ],
      type: "normal",
      deliverySlot: "",
      address: "",
      paymentMethod: "",
      paymentStatus: "",
      status: "",
      deliveryInstructions: "",
      isCancelled: false,
      cancellationReason: null,
      refundStatus: "",
      paymentAmount: parseFloat(finalPrice),
      productName: product.name,
      discountInPercent: product.discountInPercent,
      originalPrice: product.price,
      // originalQuantity: qty,
      originalQuantity: product.minWeightInGrams,
      totalAmount: totalPrice,
    };

    cart.push(orderData);
    localStorage.setItem("cart", JSON.stringify(cart));
    successmessage("Item added to cart!");
    window.dispatchEvent(new Event("storage"));
  };

  return (
    <>
      {contextHolder}
      <Card className="shadow-sm ncarditem border-0 my-2"
       onClick={() => handleNavProductDetail(product.slug)}
       style={{minWidth:"100%"}}
       >
        <div
          style={{
            background: "#F8F9FA",
            borderTopLeftRadius: "1rem",
            borderTopRightRadius: "1rem",
            position: "relative",
          }}
          className="text-center"
        >
          {product?.discountInPercent > 0 && (
            <span
              style={{
                backgroundColor: theme.color.pri,
                color: "white",
                padding: "2px 8px",
                borderRadius: "6px",
                position: "absolute",
                top: "10px",
                left: "10px",
                fontSize: "12px",
              }}
            >
              {product?.discountInPercent}% Off
            </span>
          )}
          <img
            src={`${API_URL}/images/${product?.image}`}
            alt={product?.name}
            style={{ width: "100%", height: "auto",maxHeight:"200px" }}
          />
        </div>

        <Card.Body style={{backgroundColor:theme.color.bg}}>
          <p className="mb-1">
            ⭐ {product?.rating?.toFixed(1)} 
            {/* ({product?.reviews}) */}
          </p>
          <Card.Title className="fw-bold fs-6"   style={{
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }}>{product.name}</Card.Title>
      <p className="text-muted small">
  {product?.minWeightInGrams}g{" "}
  
  {product?.pieceCount && (
    <>
      |{" "}
      {product.pieceCount.split("/")[0]} pieces{" "}
      |{" "}
      {product.pieceCount.split("/")[1]} serves
    </>
  )}
</p>

          <div className="d-flex align-items-center mb-3">
            <span className="fw-bold me-2" style={{ color: theme.color.pri }}>
              ₹{finalPrice}
            </span>
            {product.discountInPercent > 0 && (
              <span className="text-muted text-decoration-line-through">₹{totalPrice.toFixed()}</span>
            )}
          </div>

          <div className="d-flex justify-content-between gap-1 align-items-center">
            <div className="d-flex align-items-center border border-2 rounded">
              <Button variant="light" size="sm" className="pm" onClick={(e)=>{e.stopPropagation();handleDecrement();}}>
                -
              </Button>
              <span className="mx-1">{weight}</span>
              <Button variant="light" size="sm" className="pm" onClick={(e)=>{e.stopPropagation();handleIncrement();}}>
                +
              </Button>
            </div>
            <Button
              size="sm"
              className="fw-bold p-2 "
              style={{ backgroundColor: theme.color.pri, border: "none"}}
              onClick={(e) => {
                e.stopPropagation();
                handleAddToCart();
              }}
            >
              {/* <ShoppingCartIcon/> */}
              Add to Cart
            </Button>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default CardItem;
